import JSEncrypt from 'jsencrypt'

const publicKey = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoB1BqpiR7ciAQx3dGb2w
  FWY4NYTDZkSVDQV47v2vwSNQF1TTNKXNTAC7+xLowvJGmo2jPkJuTlsdJYVN1eBs
  vpK5Q+b0+nfbqUEvvLLOTa0IGOZkdAitmDAS+/lUCrVa5SxitrdJ9EVP/J/rRbx5
  6GPBuUq71+OYrUGa7hTUJ90H3JQMqigBRptOfE3bCQrZAJmzYfy4wzR7Rnl9AuLK
  QJrCU9f6MCyogtuUmwqu9nZfXNnibtgawW5mHMKZM+gm8WGaOYA9zI9MGOZrqa/d
  a3nLrx9Zn5JIvEB0bK3eRCHh1WklTediQQVq4ziuLUEWInDUH6MfkJTJUPmX6mW7
  xwIDAQAB
  -----END PUBLIC KEY-----`
const encryptor = new JSEncrypt()
encryptor.setPublicKey(publicKey) // 设置公钥

export function encryptPassword(txt) {
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}
